<div class="inline-flex gap-0 p-2 bg-primary rounded-lg shadow-sm">
  <!-- trackBy so a caller binding a getter (a new array each change-detection
       cycle) does not make Angular rebuild every button, and any mat-icon in
       them, on every cycle. -->
  <ng-container *ngFor="let button of buttons; trackBy: trackByValue">
    <button
      class="px-6 py-2 text-[11px] font-medium transition-all duration-200 rounded-md flex items-center gap-2"
      *ngIf="hasPermission(button.perms)"
      (click)="toggleActive(button.value)"
      [ngClass]="
        button.isActive
          ? 'bg-white text-primary shadow-sm'
          : 'text-white hover:bg-white/10'
      "
    >
      <mat-icon
        *ngIf="button.icon"
        [svgIcon]="button.icon"
        class="text-current"
        style="width: 14px; height: 14px"
      ></mat-icon>
      {{ button.name }}
    </button>
  </ng-container>
</div>
